import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import {
  FormElement,
  InputText,
  Panel,
  Text,
  TEXT_VARIANT_BOLD,
  TEXT_VARIANT_LIGHT,
  HelpIcon,
  Flex,
  FlexItem,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  LINK_VARIANT_HIGHLIGHT,
  SpacingVertical,
  SPACING_4
} from 'mailup-web-components'

import { useRecoilCallback, useRecoilState } from 'recoil'
import { messageState } from '../../../recoil/state/message'
import { notifyParent } from 'Helpers/notifyParent'
import { getTrackingInfoCustomParamsCallback } from '../../../recoil/callbacks/callbacks'
import ReactTooltip from 'react-tooltip'
import styled from '@emotion/styled'

const WebAnalyticsTrackingCode = () => {
  const intl = useIntl()
  // tooltip visibility
  const [tooltipVisible, setTooltipVisible] = useState(false)
  // display default text in inputbox
  const [defCustomParams, setDefCustomParams] = useState('')
  // contain customtrackingparameters, override customParams if they are the same
  const [customtrackingparameters, setCustomtrackingparameters] = useState('')
  const getTInfoCustomParamsCallback = useRecoilCallback(
    getTrackingInfoCustomParamsCallback,
    []
  )
  const [{ customParams, id }, setCustomParams] = useRecoilState(messageState)

  const handleChangeTitle = e => {
    e.stopPropagation()
    e.preventDefault()
    const value = e.target.value
    setDefCustomParams(value)
    if (value !== customtrackingparameters) {
      setCustomParams(prev => ({
        ...prev,
        customParams: value,
        isDirty: true
      }))
    } else {
      setCustomParams(prev => ({
        ...prev,
        customParams: '',
        isDirty: true
      }))
    }
  }

  const handleNotifyParent = e => {
    e.stopPropagation()
    e.preventDefault()
    notifyParent('redirectMainFrame', [
      'form_upd_nl.aspx?visualmode=1&tab=opzioni'
    ])
  }

  useEffect(() => {
    ReactTooltip.rebuild()
    if (id && !customtrackingparameters) {
      // the messagestate has been set
      getTInfoCustomParamsCallback().then(res => {
        setTooltipVisible(res && res.Tracking.Customtrackingparameters !== '')
        setCustomtrackingparameters(res.Tracking.Customtrackingparameters)
        if (customParams === '') {
          const c = res.Tracking.Customtrackingparameters
          setDefCustomParams(c)
        } else {
          const c = customParams
          setDefCustomParams(c)
        }
      })
    }
  }, [id, customtrackingparameters])

  return (
    <>
      <Panel data-mu-test='overview-message__box-web-analytics-tracking-code'>
        <Flex
          alignItems='baseline'
          justifyContent='space-between'
          height='26px'
        >
          <FlexItem>
            <Text htmlElement='span' variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SavedEmailWizard.LabelManualLinkTracking'
              })}
            </Text>

            <HelpIcon
              text={intl.formatMessage({
                id: 'Load.SavedEmailWizard.ManualLinkTrackingParamsTooltip'
              })}
            />
          </FlexItem>
          <FlexItem>
            <Link
              variant={LINK_VARIANT_EXTRALIGHT}
              onClick={handleNotifyParent}
            >
              {intl.formatMessage({
                id: 'Load.SavedEmailWizard.ManualTrackingLinkSettings'
              })}
            </Link>
          </FlexItem>
        </Flex>
        <Flex flexDirection='column'>
          <InputTextContainer>
            <SpacingVertical variant={SPACING_4} />
            <Text>
              {intl.formatMessage({
                id: 'Load.SavedEmailWizard.LabelManualLinkTrackingParams'
              })}
            </Text>
            <FormElement>
              <div className='p-relative'>
                <InputText
                  placeholder={
                    tooltipVisible &&
                    intl.formatMessage({
                      id:
                        'Load.SavedEmailWizard.WebAnalyticsTrackingCodePlaceholder'
                    })
                  }
                  onChange={handleChangeTitle}
                  maxLength='400'
                  value={defCustomParams}
                  data-mu-test='input-preheader'
                  className={tooltipVisible ? 'p-40' : ''}
                />
                {tooltipVisible && (
                  <HelpIcon
                    text={intl.formatMessage({
                      id:
                        'Load.SavedEmailWizard.ManualLinkTrackingParamsTooltip'
                    })}
                    className='p-absolute'
                  />
                )}
              </div>
            </FormElement>
          </InputTextContainer>

          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage({
              id: 'Load.SavedEmailWizard.WebAnalyticsTrackingCodeInputExample'
            })}
          </Text>
          <Text variant={TEXT_VARIANT_LIGHT}>
            {intl.formatMessage(
              {
                id:
                  'Load.SavedEmailWizard.WebAnalyticsTrackingCodeInputLinkIntl'
              },
              {
                link: content => (
                  <Link
                    variant={LINK_VARIANT_HIGHLIGHT}
                    key={content}
                    target='blank'
                    href='https://ga-dev-tools.appspot.com/campaign-url-builder'
                  >
                    {content}
                  </Link>
                )
              }
            )}
          </Text>
        </Flex>
      </Panel>
    </>
  )
}

export default WebAnalyticsTrackingCode

const InputTextContainer = styled.div`
  .p-40 > input {
    padding-right: 40px !important;
  }

  .p-relative {
    position: relative;
    margin: 8px 0;
  }

  .p-absolute {
    position: absolute;
    right: 12px;
    top: 8px;
  }
`
